import services from './../../../services/service'; // Service Class
import validation from './../../../services/validation'; // Validation

let service = new services();
let validator = new validation();
export default {
    name: 'ManageTemplate',
    data () {
        return {
           
        }
    },
    components: {},
    methods: {
   

     
    },
    created: function(){
       // if(this.path_name == 'Sellpoint'){this.setPageHeaders();} //for sellpoint only
    }
}


// WEBPACK FOOTER //
// ./src/pages/Manage/ManageSet/script.js